<template>
    <v-row class="listing">
        <v-col v-if="!isSmall" class="end" sm="2" cols="4">
            <slot name="item-icon"></slot>
        </v-col>
        <v-col style="padding: 0px;" class="center" :sm="!isSmall ? 9 : 12" :cols="!isSmall ? 8 : 12">
            <v-card class="listing-card" :class="jobType">
                <slot name="item-details"></slot>
            </v-card>
        </v-col>
    </v-row>
</template>

<style lang="scss" scoped>
@import '../../../styles/styles.scss';

.listing {
    padding: 0px 2em;
}
</style>

<script>
export default {
    name: 'listing-item',
    props: {
        jobType: {
            type: String,
            default: 'general'
        }
    },
    data: () => ({}),
    computed: {
        isSmall() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return true
                default:
                    return false
            }
        }
    }
}
</script>
